import { lazy } from 'react';
import RedirectionScreen from '../views/pages/RedirectionScreen';
import WelcomeScreen from '../views/dashboard/WelcomeScreen';
import MainRoutes from './MainRoutes';
import OnboardingV2 from '../views/onboarding-v2';
import StartupDetail from '../views/startupDetail'
import PitchDeck from '../views/PitchDeck';
import WhatsAppSuccessScreen from '../views/pages/WhatsAppSuccessScreen';
import { Navigate, Outlet } from 'react-router-dom';
import LogoutScreen from 'views/pages/LogoutScreen';
import ClaimProfilePage from 'views/onboarding/miscellaneous/ClaimProfilePage';
import PersonalDetails from 'views/onboarding/miscellaneous/PersonalDetailsPopup';
import SingleSignOn from 'views/pages/SingleSignOn';

// // login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| ONBOARDING ROUTING ||============================== //

const CreatProfileRoutes = {
    path: '',
    // element: <ProfileInformation />,
    children: [
        // {
        //     // New 3-step onboarding (built alongside the old wizard, which is untouched).
        //     path: '/onboardingv2',
        //     element: <OnboardingV2 />,
        // },
        {
            path: '',
            element:  <Outlet />,
            children: [
                {
                    path: "",
                    element: <OnboardingV2 />
                },
                {
                    path: "onboarding",
                    element: <OnboardingV2 />
                },
                {
                    path: '/activate-profile',
                    element: <ClaimProfilePage />,
                },
                // {
                //     path: '/activate-profile',
                //     element: <PersonalDetails />,
                // },
                // {
                //     path: '/startup_information',
                //     element: <StartupInformation />,
                // },
                {
                    path: "*",
                    element: <OnboardingV2 />
                },
                // { ...MainRoutes }
            ]
        },
        {
            path: '/thank-you',
            element: <RedirectionScreen />,
        },
        {
            path: '/whatsApp-success',
            element: <WhatsAppSuccessScreen />,
        },
        {
            path: "/logout",
            element: <LogoutScreen />
        },
        {
            path: '/cHJpdmF0ZS1yb3V0ZQ==',
            element: <SingleSignOn />,
        },
    ]
};

export default CreatProfileRoutes;
